"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("./constants");

var _RawTextField = _interopRequireDefault(require("./components/RawTextField"));

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var NUMERIC_REGEX = /[^0-9]/g;

var removeNonNumbers = function removeNonNumbers(value) {
  return value.replace(NUMERIC_REGEX, '');
};

var IdentificationField = function IdentificationField(props) {
  var country = IdentificationField.Countries[props.country];
  return _react.default.createElement(_RawTextField.default, _extends({}, country, props, {
    value: country.format(props.value),
    onChange: function onChange(value, event) {
      return props.onChange(removeNonNumbers(value), value, event);
    },
    maxLength: 11 // 9 #s+ "- -"

  }));
};

IdentificationField.Sizes = _RawTextField.default.Sizes;
IdentificationField.Countries = _constants.Countries;
IdentificationField.propTypes = (0, _lodash.default)(_RawTextField.default.propTypes, ['type', 'isMultiline']);
IdentificationField.defaultProps = _objectSpread({}, _RawTextField.default.defaultProps, {
  country: 'US',
  description: 'Required'
});
var _default = IdentificationField;
exports.default = _default;